var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.4248 16.5752H2.46966L12.9894 6.05541L11.9446 5.01055L1.4248 15.5303V16.5752ZM16.0053 5.0343L12.9657 1.99472L14.9604 0L18 3.03958L16.0053 5.0343ZM0 18V14.9604L11.9683 2.99208L15.0079 6.03166L3.03958 18H0ZM12.467 5.53298L11.9446 5.01055L12.9894 6.05541L12.467 5.53298Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.bb6883380c9c567df84382d1063fb1f3.svg";
export { ForwardRef as ReactComponent };